module.exports = __webpack_public_path__ + "static/media/up.16be5510.svg";